import { TypeAsserter, TypeChecker } from '@attain-apps/type-guards'

import type * as common from '../../../../common'

const MARKER_SYMBOL = Symbol.for('@attain-apps/dms.expression.Node')

/**
 * Used in a query graph to represent an expression
 *
 * __NOTE:__ this is just a marker class. The real content is in the subclasses
 */
export abstract class Node<T = unknown> {
  /**
   * This only exists so that `{}` does not extend {@link Node}
   *
   * We've had issues where someone returned something like
   * `Partial<Record<string, ...>>` where they were supposed to return a `Node`
   * and TypeScript wasn't complaining
   */
  public readonly [MARKER_SYMBOL] = true as const

  /**
   * Just used to put the type parameter to use so that Node<string> !=
   * Node<number>
   *
   * The type parameter is actually used by the subclasses
   */
  declare private readonly _marker?: T

  /**
   * Return type of this expression. If `undefined` that means the return type
   * is unknown
   */
  public abstract readonly type?: common.value.types.Type
}
export namespace Node {
  export const isNode: TypeChecker<Node> = TypeChecker.Factory.lazy(() =>
    TypeChecker.Factory.instance(Node),
  ).usingAlias('dms.node.Node')
  export const assertIsNode: TypeAsserter<Node> =
    TypeAsserter.Factory.from(isNode)
}
